import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

// goodDirection: which direction is favourable ("up" or "down")
export const Delta = ({ value, suffix = "%", goodDirection = "up", className, prefixText }) => {
    const v = Number(value);
    const isGood = goodDirection === "up" ? v > 0 : v < 0;
    const isBad = goodDirection === "up" ? v < 0 : v > 0;
    const tone = v === 0 ? "text-muted-foreground" : isGood ? "text-success" : isBad ? "text-destructive" : "text-muted-foreground";
    const Icon = v > 0 ? ArrowUpRight : v < 0 ? ArrowDownRight : Minus;
    return (
        <span className={cn("inline-flex items-center gap-0.5 text-xs font-semibold tabular", tone, className)}>
            <Icon className="h-3.5 w-3.5" strokeWidth={2.4} />
            {v > 0 ? "+" : ""}
            {v}
            {suffix}
            {prefixText && <span className="ml-1 font-normal text-muted-foreground">{prefixText}</span>}
        </span>
    );
};
